module.exports = __webpack_public_path__ + "static/mobile-banner-859fce52b9edd31eae6af3951d5fa038.svg";